<template>
  <div
    class="title-yellow mb-5 d-flex align-items-center justify-content-center"
    :class="{ 'title-yellow--fit': fit }"
  >
    <component :is="tag" class="text-center m-0 py-2 px-lg-5 mx-lg-5">{{ text }}</component>
  </div>
</template>

<script>
/**
 * Banda amarilla con el título de una sección (mismo estilo que
 * "GENÉTICAS DESTACADAS" del Home).
 *
 * Componente ÚNICO para que el Home, la Galería y el Blog no se desincronicen.
 *
 * Props:
 *  - text: String (obligatorio) — texto del título (el CSS lo pasa a mayúsculas).
 *  - tag:  String (default 'h1')  — etiqueta del título (h1/h2) para respetar la semántica de cada página.
 *  - fit:  Boolean (default false) — variante CHIP para superponer sobre una imagen (ej. hero de la
 *          galería): el fondo amarillo se ajusta al texto (no ocupa todo el ancho) y la tipografía
 *          baja a un tamaño de etiqueta.
 */
export default {
  name: 'TitleYellow',
  props: {
    text: { type: String, required: true },
    tag: { type: String, default: 'h1' },
    fit: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.title-yellow {
  background-color: var(--primary-color);
  /* El h1/h2 hereda color y tipografía (no define ninguna de las dos) */
  color: var(--title-blue-color);
  font-family: 'Adumu', sans-serif;
}

/* Mismo tratamiento que en el Home: texto en mayúsculas */
.title-yellow :deep(h1),
.title-yellow :deep(h2) {
  text-transform: uppercase;
}

/* Variante chip: el amarillo se ajusta al texto, centrado y con tamaño de etiqueta */
.title-yellow--fit {
  width: fit-content;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.title-yellow--fit :deep(h1),
.title-yellow--fit :deep(h2) {
  font-size: clamp(2rem, 3vw, 2.35rem);
  /* mx-lg-5 / px-lg-5 son utilities de Bootstrap (!important): los pisamos */
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
</style>
